export default import.meta.ROLLDOWN_FILE_URL_0BR8Yy9gzUm4Ct7fdNKHZg